import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Scissors, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Accesso effettuato");
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err, "Accesso non riuscito. Verifica le credenziali."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-[0_12px_40px_rgba(2,132,199,0.08)] p-8">
          <div className="flex items-center gap-3 mb-2">
            <img src="/logo.jpg" alt="Morselli Renzo" className="h-12 w-auto" />
            <div>
              <h1 className="font-serif text-2xl font-semibold text-slate-900">Area Riservata</h1>
              <p className="text-xs uppercase tracking-[0.15em] text-sky-700">Gestione Morselli Renzo</p>
            </div>
          </div>
          <p className="text-sm text-slate-500 mt-3 mb-6">
            Solo il titolare può accedere per aggiungere o modificare le macchine disponibili e gestire le richieste d'ordine.
          </p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="a-email">Email</Label>
              <Input id="a-email" type="email" required data-testid="admin-login-email"
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder="morselli.r@libero.it" />
            </div>
            <div>
              <Label htmlFor="a-pass">Password</Label>
              <Input id="a-pass" type="password" required data-testid="admin-login-password"
                value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="admin-login-submit"
              className="w-full bg-sky-600 hover:bg-sky-700 text-white rounded-full py-5">
              {loading ? "Accesso in corso..." : "Accedi alla Dashboard"}
            </Button>
          </form>
        </div>
        <Link to="/" data-testid="back-to-site-link"
          className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-sky-700 mt-6 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Torna al sito pubblico
        </Link>
      </div>
    </div>
  );
}
